import { render, staticRenderFns } from "./smartbiz.vue?vue&type=template&id=5f32d69f"
import script from "./smartbiz.vue?vue&type=script&lang=js"
export * from "./smartbiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports